<template>
  <div>
    <div class='row no-gutters'>
      <div class='col'>
        <div class='toggleBox'>
          <label>
            <input v-model='wantsMedical' id='wantsMedical' type='checkbox'><span style='border-radius: 9px 9px 0 0; cursor: pointer;margin-top:-3px;'>{{$t("text.page2_input2")}}</span>
          </label>
        </div>
      </div>
      <div class='col-auto'>
        <button class="moreHelp" style='margin-left: 10px;' @click="openTooltip($t('text.page2_tooltip3'))" :aria-label="$t('text.moreinformation') + $t('text.page2_input2')">
          <img src='../assets/images/helpIcon.png' alt=""/>
        </button>
      </div>
    </div>
    <div class='row no-gutters'>
      <div class='col'>
        <div class='toggleBox' >
          <label>
            <input v-model='wantsCancellation' id='wantsCancellation' type='checkbox'><span style='border-radius: 0 0 9px 9px; cursor: pointer;margin-top:-1px;'>{{$t("text.page2_input1")}}</span>
          </label>
        </div>
      </div>
      <div class='col-auto'>
        <button class="moreHelp" v-if='this.$store.state.site==="cibc"' style='margin-left: 10px;'  @click="openTooltip($t('text.page2_tooltip2'))" :aria-label="$t('text.moreinformation') + $t('text.page2_input1')">
          <img src='../assets/images/helpIcon.png' alt=""/>
        </button>
        <button class="moreHelp" v-else href='javascript:void(0);' style='margin-left: 10px;'  @click="openTooltip($t('text.page2_tooltip2nm'))" :aria-label="$t('text.moreinformation') + $t('text.page2_input1')">
          <img src='../assets/images/helpIcon.png' alt=""/>
        </button>
      </div>
    </div>
    <br/>
    <div class='row'>
      <div style='margin-left: 15px; margin-right:50px; padding:30px; padding-bottom:14px; border: 1px solid #ccc;'>
        <span v-if='this.$store.state.site==="cibc"' v-html="$t('text.page1_existingCoverage')"></span>
        <span v-else v-html="$t('text.page1_existingCoveragenm')"></span>
      </div>
    </div>
    
  </div>
</template>

<style>
.toggleBox input:checked + span {
    background-color:#333333 !important;
    color:#fff;
}
.toggleBox span {
  color: #333333;
  background-color: #FFFFFF;
  border: 1px solid #CCCCCC;
  font-size: 16px;
  line-height: 24px;
  padding: 30px;

  width: 100%;
  margin:0px;
  display: block;  
}
.toggleBox label {
  margin:0px;
    width: 100%;
}
.toggleBox label input {
    position:absolute;
    left:25px;
    z-index: -1;
}
.toggleBox input:hover + span {
  background-color: #EEEEEE;
}

</style>

<script>
import { validationRules } from "../utils/validation_rules.js";
import { validateForm, validateField } from "../utils/validation.js";
import bus from "../utils/bus.js";

export default {
  computed: {
    wantsCancellation:{
      get(){
      },
      set(){
        this.proceedButton();
      }
    },
    wantsMedical:{
      get(){

      },
      set(){
        this.proceedButton();
      }
    }
  },
  methods: {
    proceedButton(){
      if(document.getElementById("wantsCancellation").checked||document.getElementById("wantsMedical").checked){
        document.getElementById("nav_next_disabled").classList.add("d-none");
        document.getElementById("nav_next_enabled").classList.remove("d-none");
      }
      else {
        document.getElementById("nav_next_disabled").classList.remove("d-none");
        document.getElementById("nav_next_enabled").classList.add("d-none");
      }
    },
    openTooltip(text) {
      document.getElementById("keywordBody").innerHTML=text;
      this.$nextTick(()=>{
        document.getElementById("keywordBody").focus();
      });
      bus.$emit("openModal");
    }
  },
  mounted() {
    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}
    
    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });

    // Set initial state of checkboxes.
    if (this.$store.state.wantsCancellation === true) {
      document.getElementById("wantsCancellation").checked=true;
    }
    if (this.$store.state.wantsMedical === true) {
      document.getElementById("wantsMedical").checked=true;
    }

    // Set listeners on checkboxes to mimic focus
    document.getElementById("wantsCancellation").addEventListener("focus", (event)=> {
      event.target.nextSibling.classList.add("isFocused");
    });
    document.getElementById("wantsCancellation").addEventListener("blur", (event)=> {
      event.target.nextSibling.classList.remove("isFocused");
    });
    document.getElementById("wantsCancellation").nextSibling.addEventListener("mouseout", (event)=> {
      event.target.classList.remove("isFocused");
    });
    document.getElementById("wantsMedical").addEventListener("focus", (event)=> {
      event.target.nextSibling.classList.add("isFocused");
    });
    document.getElementById("wantsMedical").addEventListener("blur", (event)=> {
      event.target.nextSibling.classList.remove("isFocused");
    });
    document.getElementById("wantsMedical").nextSibling.addEventListener("mouseout", (event)=> {
      event.target.classList.remove("isFocused");
    });
    
    this.proceedButton();

  },
};
</script>